export const uniqueVinculaciones = rows => Array.from(new Map(
  rows.map((row, index) => [row.idPrincipal ?? row.id ?? `row-${index}`, row])
).values())
